import { Dispatch } from 'react';
import { get, post, put, remove } from 'communication/httpClient';
import { IGenericObject } from 'types';
import {
  SET_PLUMENU_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  CREATE_INITIATED,
  UPDATE_INITIATED,
  DELETE_INITIATED,
  PLUMENU_DELETED,
  PLUMENU_CREATED,
  PLUMENU_UPDATED,
  CLEAN_PLUMENU,
  SET_PLUMENU,
  SET_PLUMENU_ASSOCIATED_GROUPS,
} from './actionTypes';
import { IPLUMenuState, IPLUMenusAction, IPLUMenusActions } from './types';
import { cleanObject } from 'utils/object';

export const initialActionsState = {
  loadPLUMenus: () => {},
  loadPLUMenu: () => {},
  savePLUMenu: () => {},
  deletePLUMenu: () => {},
  loadPLUAssociateGroups: () => {},
  cleanPLUMenu: () => {},
};

export const getActions = (dispatch: Dispatch<IPLUMenusAction>): IPLUMenusActions => ({
  loadPLUMenus: async (params: IGenericObject) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/plu-menu`, { params: cleanObject(params) });

    if (data) {
      dispatch({
        type: SET_PLUMENU_LIST,
        payload: data.pageContent,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadPLUMenu: async (id: string) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/plu-menu/${id}`);

    if (data) {
      dispatch({
        type: SET_PLUMENU,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  savePLUMenu: async (pluMenu: IPLUMenuState, id: string, callback?: (pluMenuId) => void) => {
    const isNew = !id;
    dispatch({
      type: isNew ? CREATE_INITIATED : UPDATE_INITIATED,
    });
    const handler = isNew ? post : put;
    const url = `/api/plu-menu/${isNew ? pluMenu.pluMenuId : id}`;
    const { error } = await handler(url, pluMenu);

    if (!error) {
      dispatch({
        type: isNew ? PLUMENU_CREATED : PLUMENU_UPDATED,
      });
      callback?.(pluMenu.pluMenuId);
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  deletePLUMenu: async (id: string, callback?: () => void) => {
    dispatch({
      type: DELETE_INITIATED,
    });
    const { data, error } = await remove(`/api/plu-menu/${id}`);

    if (data || data === '') {
      dispatch({
        type: PLUMENU_DELETED,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadPLUAssociateGroups: async (params: IGenericObject) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/plu-menu/associated-groups`, {
      params: cleanObject(params),
    });
    const withFilterParams = params && Object.entries(params)?.length > 0;
    if (data) {
      dispatch({
        type: SET_PLUMENU_ASSOCIATED_GROUPS,
        payload: {
          pluAssociatedGroups: data,
          filtering: withFilterParams ? true : false,
          pluActiveGroupIds: data
            .map((group) => {
              const subGroupIds = group?.subGroups?.map((subGroup) => subGroup?.groupId);
              return [group?.groupId, ...subGroupIds];
            })
            .flat(),
        },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  cleanPLUMenu: () => {
    dispatch({
      type: CLEAN_PLUMENU,
    });
  },
});
